import { OTPLessResponse } from '../../types/common.type';

type OtpPayloadInitiateType = {
  otp?: string;
  channel: string;
  phone: string;
  countryCode: string;
  expiry?: number;
};

//It gives and undefined type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let OTPlessSignin: any;

export async function OTPlessSdk(): Promise<void> {
  return new Promise<void>((resolve) => {
    if (document.getElementById('otpless-sdk') && OTPlessSignin)
      return resolve();

    const script = document.createElement('script');
    script.src = 'https://otpless.com/v4/headless.js';
    script.id = 'otpLess-sdk';

    script.setAttribute(
      'data-appid',
      process.env.REACT_APP_OTPLESS_DATA_APP_ID as string,
    );

    const callback = (eventCallback: { response: { token: string } }): void => {
      const ONETAP = () => {
        const { response } = eventCallback;
        return response;
      };

      const FAILED = () => {
        const { response } = eventCallback;
        return response;
      };

      const FALLBACK_TRIGGERED = () => {
        const { response } = eventCallback;
        return response;
      };

      const EVENTS_MAP: { [key: string]: () => void } = {
        FAILED,
        ONETAP,
        FALLBACK_TRIGGERED,
      };

      if ('responseType' in eventCallback)
        EVENTS_MAP[eventCallback.responseType as string]();
    };

    script.onload = function () {
      const OTPless = Reflect.get(window, 'OTPless');
      OTPlessSignin = new OTPless(callback);
      resolve();
    };
    document.head.appendChild(script);
  });
}

export async function hitOTPlessSdk(params: {
  requestType: string;
  request: OtpPayloadInitiateType;
}) {
  await OTPlessSdk();

  const { requestType, request } = params;

  const getOtpResponse: OTPLessResponse =
    await OTPlessSignin?.[requestType]?.(request);
  return getOtpResponse;
}

/**  Otpless callback function
 * @description
 * This function is called after authentication is done, by otpless-sdk.
 * Use this function to further process the otplessUser object, navigate to next page or perform any other action based on your requirement.
 * @param {Object} eventCallback
 * @returns {void}
 */

export async function initiate(
  phoneNumber: string,
  countryCode: string,
  expiry: number,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> {
  const request = {
    channel: 'PHONE',
    phone: phoneNumber,
    countryCode: countryCode,
    expiry: expiry,
  };

  const initiate = await hitOTPlessSdk({
    requestType: 'initiate',
    request,
  });

  return initiate;
}

export async function verify(phone: string, otp: string, countryCode: string) {
  const verify: OTPLessResponse = await hitOTPlessSdk({
    requestType: 'verify',
    request: {
      channel: 'PHONE',
      phone: phone,
      otp: otp,
      countryCode: countryCode,
    },
  });

  return verify;
}
